'use client'
import React, { useContext, useEffect, useState } from 'react';
import { MenuList } from '@/components/menuList';
import { Box, Flex, Text } from '@chakra-ui/layout';
import ProfileThumbnail from '@/profile/component/profileThumbnail';
import { MdArrowDropDown } from 'react-icons/md';
import { Menu, MenuButton, MenuItem } from '@chakra-ui/menu';
import { Button, Skeleton, Tag, TagLabel } from '@chakra-ui/react';
import roleDictionnary from '@/lib/roleDictionnary';
import useProductsApi from '../../lib/useProductsApi';
import memberStatusDictionnary from '@/lib/memberStatusDictionnary';
import ProfileProvider from '@/profile/lib/profileProvider';
import { ProductContext } from '../../lib/productContext';
import { ProfileContext } from '@/profile/lib/profileContext';
import { AuthContext } from '@/auth/lib/authContext';
import useProfileApi from '@/profile/lib/useProfileApi';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ProductMemberListItem(props) {
  const { t } = useTranslation();
  const {
    productId,
  } = useContext(ProductContext);
  const { profile } = useContext(ProfileContext);
  const authContext = useContext(AuthContext);
  const {
    onRevoke,
    onRoleUpdated
  } = props;
  const navigate = useNavigate();
  const productApi = useProductsApi();
  const profileApi = useProfileApi();
  const [profileId, setProfileId] = useState()
  const [newProfileId, setNewProfileId] = useState();
  const [itemRole, setItemRole] = useState()
  const [approving, setApproving] = useState(false)
  const [fetchingData, setFetchingData] = useState(false)
  const [role, setRole] = useState()
  const [hasRequestedEdition, setHasRequestedEdition] = useState()
  const [status, setStatus] = useState()
  const [email, setEmail] = useState()
  const fetchData = async () => {
    try {
      setFetchingData(true);
      const promises = [
        productApi.fetchMemberRole(
          productId,
          profile.id
        ),
        productApi.fetchMemberStatus(productId, profile.id),
        productApi.hasRequestedEdition(productId, profile.id),
        productApi.fetchMemberRole(productId, authContext.profile.id),
        profileApi.fetchEmailByProfileId(profile.id)
      ];
      const result = await Promise.all(promises)
      setItemRole(result[0]);
      setStatus(result[1]);
      setHasRequestedEdition(result[2]);
      setRole(result[3]);
      setEmail(result[4]);
      setFetchingData(false);
    } catch (e) {
      console.error(e)
    }
  };
  const updateRole = async (role) => {
    try {
      await productApi.updateRole(productId, profile.id, role);
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error);
    }
  }
  const revokeAccess = async () => {
    try {
      await productApi.revokeAccess(productId, profile.id);
      if (onRevoke) {
        onRevoke();
      }
    } catch (error) {
      console.error(error)
    }
  }
  const leave = async () => {
    try {
      await productApi.revokeAccess(productId, authContext.profile.id);
      navigate('/products')
    } catch (error) {
      console.error(error)
    }
  }
  const approveRequest = async () => {
    try {
      setApproving(true)
      await productApi.approveRequest(productId, profile.id);
      setApproving(false)
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error)
    }
  }
  const declineRequest = async () => {
    try {
      await productApi.declineRequest(productId, profile.id);
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if(profileId) {
      fetchData()
    }
  }, [profileId]);
  useEffect(() => {
    if (newProfileId !== profileId) {
      setProfileId(newProfileId)
    };
  }, [newProfileId]);
  useEffect(() => {
    if (profile.id && productId && authContext.hasProfile) {
      setNewProfileId(profile.id);
    }
  }, [profile.id, productId, authContext.hasProfile]);
  return (
    <>
      {profile && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={3}
          backgroundColor="white"
        >
          <Flex alignItems={'center'}>
            <ProfileProvider
              profileId={profile.id}
              originalProfile={profile}>
              <ProfileThumbnail size={40} />
            </ProfileProvider>
            <Flex ml={2} flexDirection={"column"}>
              <Text>{profile.pseudo} {authContext.profile.id === profile.id ? '(Me)' : ''} </Text>
              {email && <Text fontSize={"11px"} color="text.medium.grey">{email}</Text>}
            </Flex>
          </Flex>
          <Flex flexDirection={"column"} alignItems={"flex-end"}>
            {fetchingData && <Skeleton width={"100px"} height={"30px"}/>}
            {status === memberStatusDictionnary.approved && (
              <>
                {((itemRole && itemRole !== roleDictionnary.owner)
                  && (role && role === roleDictionnary.owner)) && (
                    <Menu ml={2} >
                      {({ isOpen }) => (
                        <>
                          <MenuButton
                            isActive={isOpen}
                            as={Button}
                            rightIcon={<MdArrowDropDown />}
                            variant='tertiary'
                            textTransform={'capitalize'}
                            p={0}
                          >{itemRole}</MenuButton>
                          <MenuList>
                            {hasRequestedEdition &&
                              (<>
                                <MenuItem onClick={approveRequest} >
                                  <Text color='text.medium.green' >{t('subscription.approveEditionRequest')}</Text>
                                </MenuItem>
                                <MenuItem onClick={declineRequest} >
                                  <Text color='text.medium.red' >{t('subscription.declineEditionRequest')}</Text>
                                </MenuItem>
                              </>
                              )}
                            {(itemRole && itemRole !== roleDictionnary.contributor) && <MenuItem onClick={() => { updateRole(roleDictionnary.contributor) }} >{t('common.contributor')}</MenuItem>}
                            {(itemRole && itemRole !== roleDictionnary.viewer) && <MenuItem onClick={() => { updateRole(roleDictionnary.viewer) }}>{t('common.viewer')}</MenuItem>}
                            <MenuItem onClick={revokeAccess} >
                              <Text color='text.medium.red' >{t('common.revokeAccess')}</Text>
                            </MenuItem>
                          </MenuList>
                        </>
                      )}
                    </Menu>
                  )}
                {((
                  itemRole && itemRole === roleDictionnary.owner)
                  || (role && role !== roleDictionnary.owner)
                  || !role)
                  && (
                    <>
                      {(profile.id !== authContext.profile.id
                        || (itemRole && itemRole === roleDictionnary.owner))
                        &&
                        <Text
                          textTransform={'capitalize'}
                          color="text.tertiaryGrey"
                        >{itemRole}</Text>
                      }
                      {(profile.id === authContext.profile.id
                        && itemRole && itemRole !== roleDictionnary.owner)
                        &&
                        <Menu ml={2} >
                          {({ isOpen }) => (
                            <>
                              <MenuButton
                                isActive={isOpen}
                                as={Button}
                                rightIcon={<MdArrowDropDown />}
                                variant='transparent'
                                p={0}
                                width={"fit-content"}
                                textTransform={'capitalize'}
                              >{itemRole}</MenuButton>
                              <MenuList>
                                <MenuItem onClick={leave}>
                                  <Text color='text.medium.red' >{t('common.leave')}</Text>
                                </MenuItem>
                              </MenuList>
                            </>
                          )}
                        </Menu>
                      }
                    </>
                  )}
              </>
            )}
            {(role !== roleDictionnary.owner && status === memberStatusDictionnary.requested) && (
              <>
                <Tag variant="orange">
                  <TagLabel>{t('common.requested')}</TagLabel>
                </Tag>
              </>
            )}
            {(role === roleDictionnary.owner && status === memberStatusDictionnary.requested) && (
              <Box>
                <Button variant="greenFill"
                  onClick={approveRequest}
                  isLoading={approving}>{t('common.approve')}</Button>
                <Button ml={1} variant="redFill" onClick={revokeAccess}>{t('common.decline')}</Button>
              </Box>
            )}
          </Flex>
        </Flex>
      )}
    </>
  )
}
